var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layoutComponent,_vm._b({tag:"component"},'component',_vm.layoutProps,false),[_c('template',{slot:"field"},[_c('form-card',{attrs:{"html":_vm.htmlData}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }